module.exports = __webpack_public_path__ + "fonts/Arnhem-NormalItalic.13e2376.woff";